/*
  Mobile: the sticky cart (weight select + add to cart) shows from the first
  screen on, not only after scrolling past the whole product section. On the
  phone the buy area sits well below the fold, image and thumbnails fill the
  first view. The bar hides only while the product's own buy buttons are in
  view, so both never show at once. Desktop keeps the theme's scroll logic.
*/
(() => {
  const mobile = window.matchMedia('(max-width: 989px)');

  document.querySelectorAll('animate-sticky.sticky-cart-wrapper').forEach((sticky) => {
    const section = sticky.closest('section') || document;
    const buyButtons = section.querySelector('.product__info-container product-form');
    if (!buyButtons || !sticky.onScrollHandler) return;

    const observer = new IntersectionObserver(([entry]) => {
      window.requestAnimationFrame(() => sticky.toggleAttribute('animate', !entry.isIntersecting));
    });

    const apply = () => {
      if (mobile.matches) {
        window.removeEventListener('scroll', sticky.onScrollHandler);
        observer.observe(buyButtons);
      } else {
        observer.disconnect();
        window.addEventListener('scroll', sticky.onScrollHandler, false);
        sticky.onScrollHandler();
      }
    };

    apply();
    mobile.addEventListener('change', apply);
  });
})();
